<template>
  <el-dialog :close-on-click-modal="false" title="税收分类管理" :visible.sync="isShow" width="600px">
    <div>
      <el-button style="float:right;margin-bottom: 10px;" type="primary" round @click="addType()">新增分类</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%;" border>
      <el-table-column prop="rateName" label="税收分类名称" width="180"></el-table-column>
      <el-table-column prop="rateCode" label="税收分类编码" width="180"></el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <span class="color-blue" @click="deleteConfirm(scope)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button round type="primary" @click="isShow = false">确 定</el-button>
    </span>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" append-to-body title="删除确认" :visible.sync="deleteDialog" width="400px">
      <span>确认删除该税收分类吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="deleteDialog = false">取 消</el-button>
        <el-button round type="primary" @click="deleteType()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <rateTypeAddVue ref="rateTypeAddVue" @success='onSubmit()'></rateTypeAddVue>
  </el-dialog>
</template>

<script>
import { taxRateTypeListAll, taxRateTypeDelete } from '@/api/finance.js'
import rateTypeAddVue from './rateTypeAdd.vue'
export default {
  components: {
    rateTypeAddVue
  },
  data () {
    return {
      loading: false,

      isShow: false,
      deleteDialog: false,
      tableData: [],
      deleteId: ''
    }
  },
  methods: {
    show () {
      this.isShow = true
      this.onSubmit()
    },
    deleteConfirm (scope) {
      this.deleteId = scope.row.taxRateTypeId
      this.deleteDialog = true
    },
    deleteType () {
      if (this.loading) return
      this.loading = true
      taxRateTypeDelete(this.deleteId)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.onSubmit()
            this.deleteDialog = false
          }
        }).finally(() => {
          let timer = setTimeout(() => {
            this.loading = false
            clearTimeout(timer)
          }, 500)
        })
    },
    onSubmit () {
      taxRateTypeListAll()
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data
          }
        })
    },
    addType () {
      this.$refs.rateTypeAddVue.show()
    }
  }
}
</script>

<style>
</style>
